/**
 * Firebase — web entry point.
 * On web, Metro resolves app/services/Firebase to Firebase.web.ts, which re-exports this file.
 * Exports the same API as Firebase.ts using the Firebase JS SDK directly.
 */
import Constants from 'expo-constants';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { getApp, getApps, initializeApp } from 'firebase/app';
import {
  getAuth,
  isSignInWithEmailLink,
  onAuthStateChanged,
  signInWithCustomToken,
  signInWithEmailLink,
  signOut,
} from 'firebase/auth';
import { fetchAndActivate, getAll, getRemoteConfig, getValue } from 'firebase/remote-config';

if (getApps().length === 0) {
  const config = Constants.expoConfig?.web?.config?.firebase;
  if (!config) throw new Error('missing required firebase web config');
  initializeApp(config);
}

// JS SDK doesn't export setConfigSettings — settings are assigned directly on the instance.
function setConfigSettings(
  remoteConfig: ReturnType<typeof getRemoteConfig>,
  settings: Partial<{ minimumFetchIntervalMillis: number; fetchTimeoutMillis: number }>
): Promise<void> {
  Object.assign(remoteConfig.settings, settings);
  return Promise.resolve();
}

export {
  getApp,
  getApps,
  initializeApp,
  getAuth,
  onAuthStateChanged,
  signInWithCustomToken,
  signInWithEmailLink,
  isSignInWithEmailLink,
  signOut,
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
  getRemoteConfig,
  fetchAndActivate,
  getAll,
  getValue,
  setConfigSettings,
};

const crashlyticsStub = {
  log: () => {},
  recordError: () => {},
  setUserId: () => Promise.resolve(null),
  setAttribute: () => Promise.resolve(null),
  setAttributes: () => Promise.resolve(null),
  crash: () => {},
  setCrashlyticsCollectionEnabled: () => Promise.resolve(null),
};

export const getCrashlytics = () => crashlyticsStub;
